<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="560px">
        <div class="row" v-loading="loading">
            <div class="col-12">
                <div>{{ description }}</div>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit" text="Eliminar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>
import XModal from "../XModal.vue";
import XButtonCancel from "./XButtonCancel.vue";
import XButtonSubmit from "./XButtonSubmit.vue";

export default {
    name: 'XDialogDelete',
    components: {XButtonSubmit, XButtonCancel, XModal},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        resource: {
            type: String,
            required: true,
        },
        recordId: {
            required: true,
        },
        text: {
            default: null
        }
    },
    data() {
        return {
            loading: false,
            title: '',
            description: '',
            resourceDelete: null
        }
    },
    methods: {
        handleOpen() {
            this.loading = false;
            this.title = 'Eliminar';
            this.resourceDelete = `/${this.resource}/${this.recordId}`;
            let description_additional = '';
            if (!_.isNull(this.text)) {
                description_additional = this.text;
            }
            this.description = '¿Seguro que desea eliminar el registro? ' + description_additional;
        },
        async onSubmit() {
            this.loading = true;
            await this.$http.delete(this.resourceDelete)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.clickClose();
                        this.$emit('success');
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(() => {
                    this.loading = false;
                })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
